/* tslint:disable */
/* eslint-disable */
export enum WorkDataQualityCheckType {
  ProjectInstallationDatesReversed = 'PROJECT_INSTALLATION_DATES_REVERSED',
  TaskDatesReversed = 'TASK_DATES_REVERSED',
  TaskMissingProjectAndTeam = 'TASK_MISSING_PROJECT_AND_TEAM',
  TaskAppointmentOneDateMissing = 'TASK_APPOINTMENT_ONE_DATE_MISSING',
  TaskDuplicateByProjectAndDate = 'TASK_DUPLICATE_BY_PROJECT_AND_DATE',
  TaskInstallationDatesNotSynced = 'TASK_INSTALLATION_DATES_NOT_SYNCED',
  ProjectDoneWithoutInstallationDates = 'PROJECT_DONE_WITHOUT_INSTALLATION_DATES',
  ProjectOverbilled = 'PROJECT_OVERBILLED',
  ProjectRevenueWithoutSaleDate = 'PROJECT_REVENUE_WITHOUT_SALE_DATE',
  ProjectSoldWithoutRevenue = 'PROJECT_SOLD_WITHOUT_REVENUE',
  ProjectSoldWithoutAdvisor = 'PROJECT_SOLD_WITHOUT_ADVISOR',
  DebtorPaidBeforeInvoice = 'DEBTOR_PAID_BEFORE_INVOICE',
  DebtorMaturityBeforeInvoice = 'DEBTOR_MATURITY_BEFORE_INVOICE'
}
